// import $ from 'jquery';
// import '~/js/libs/jquery.lazy';
// import '~/js/libs/bootstrap.min';
import "~/js/libs/bootstrap/index";
import "jquery.scrollbar";
import "~/js/libs/jquery.waypoint";
// import '~/js/libs/sticky';
import "~/js/modules/header-search";
import React from "react";
import ReactDOM from "react-dom";
import ProfileOptions from "./ProfileOptions";
import AccountLogin from "./AccountLogin";


const resortMenu = document.getElementById("resort-menu");

const rewardsMenu = document.getElementById("rewards-program");
const headerSignInBtn = document.getElementById("js-registry__toggle");


const accountLogin = document.querySelector(".rewards-program");


const profileOptions = document.querySelector(".profile-options");
const profileOptions2 = document.querySelector(".profile-options-2");


if(profileOptions && profileOptions.classList ){
  profileOptions.classList.remove('hide-options');
}


if(profileOptions2 && profileOptions2.classList ){
  profileOptions2.classList.remove('hide-options');
}

  
  // Display profile options
  
  const giftToggle = document.querySelectorAll("#js-registry__toggle");
  const giftModal = document.querySelectorAll(".options__modal");
  
  const getStartedBtn = document.querySelectorAll(".get-started");
  //Gift Modal
  
    getStartedBtn.forEach((item) => {
      item.addEventListener("click", () => {
        document.getElementById("agree-popup").classList.remove("hide");
      });
    });
    
    function toggleGiftModal(index) {
      giftModal[index].classList.toggle("visible");
    }
    
    giftToggle.forEach((item, index) => {
      item.addEventListener("click", () => toggleGiftModal(index));
    });
  

if (window.beaches_app.page.rstCode) {
  const rstCode = window.beaches_app.page.rstCode.toLowerCase();

  const resortList = {
    btc: "Turks & Caicos",
    bng: "Negril",
    bbo: "Ocho Rios",
  };

  const sessionStorage = window.sessionStorage;

  sessionStorage.setItem("loadResortCode", rstCode);
  sessionStorage.setItem("loadResortName", `Beaches ${resortList[rstCode]}`);
}

const header = () => {
  const QuickQuote = require("~/js/components/global/QuickQuote").default; // QQTODO
  const $document = $(document);
  const $window = $(window);
  const $body = $("body");
  const $html = $("html");
  const $header = $(".js-header");
  const $main = $(".js-main").first();
  const $mainGroupsMenuTop = $(".js-main-group-menu-top");
  const $menuBtn = $(".js-menu-btn");
  const $rewardsBtn = $(".js-login-btn");
  const $rewardsBtn2 = $(".js-login-btn-2");
  const $headerBottom = $(".js-header-bottom");
  const $mobileResorts = $(".js-mobile-resorts");
  // const $scroll = $('.js-scroll');
  const $mnContentBtn = $(".js-mn-content-btn");
  const $mnNavbarList = $(".js-mn-navbar-list");
  const $smNavbarList = $(".js-mn-navbar-sm-list");
  const $customSelects = $(".js-cr-select");
  const quickQuoteElms = document.querySelectorAll(".mm-qq"); // QQTODO
  const $bookNowButton = $(".js-hm-book-now");
  const $bookNowOverlay = $(".js-hm-book-now-overlay");
  const $bookNowCloseBtn = $(".js-hm-book-now > .icon-close");
  const $bookNowMobileBtn = $(".hm-mobile-book-btn");

  let isMenuOpen = false;
  let isResortsOpen = false;
  let scrollTop;

  // set cobrand navs
  const stickyNavs = ["resort-menu", "nav"];
  let $currentNav = $();
  let stickyNavSelector = "";

  const hasCobrand = Object.keys(beaches_app.referral).length !== 0;
  const hasNav = () => $currentNav.length !== 0;

  // look for sticky nav
  const setCurrentNav = () => {
    if (hasCobrand) {
      stickyNavs.find((navSelector) => {
        $currentNav = $("#" + navSelector);
        stickyNavSelector = navSelector;

        return hasNav();
      });
    }
  };

  // https://sanserviceshn.atlassian.net/browse/BWU-4044
  const $hiddenContent = $(".hidden-content");
  const $toggleBtnOpenResorts = $(".toggle-btn");
  const $overlayHiddenContent = $(".overlay-hidden-content");

  $toggleBtnOpenResorts.on("click", () => {
    /// $toggleBtnOpenResorts.find('.chevron-sm').toggleClass('bottom');
    $toggleBtnOpenResorts.find(".icon-close").toggleClass("hide");
    $toggleBtnOpenResorts.find(".chevron-sm").toggleClass("hide");
    $hiddenContent.toggleClass("show").focus();
    $overlayHiddenContent.toggleClass("show");
  });

  $hiddenContent.on("keydown", (e) => {
    if (e.keyCode === 27) {
      $toggleBtnOpenResorts.trigger("click");
    }
  });

  $overlayHiddenContent.on("click", () => {
    $toggleBtnOpenResorts.trigger("click");
  });

  // get top of elem
  const getTop = (elem) => {
    const box = elem.getBoundingClientRect();

    const body = document.body;
    const docEl = document.documentElement;

    const scrollTopNav =
      window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const top = box.top + scrollTopNav - clientTop;

    return Math.round(top);
  };

  // if has cobrand add paddings
  if (hasCobrand) {
    const body = document.getElementsByTagName("body")[0];
    const cobrandPaddingElement = document.createElement("div");

    // add padding to main page
    cobrandPaddingElement.classList.add("js-cobrand-padding");
    cobrandPaddingElement.style.height = $(".js-cobrand").height() + "px";
    body.insertBefore(cobrandPaddingElement, body.firstChild);

    setCurrentNav();
    if (hasNav()) {
      const navInitialTop =
        getTop(document.getElementById(stickyNavSelector)) < 158
          ? " nav-top"
          : "";

      $currentNav.addClass("has-cobrand" + navInitialTop);
    }
  }

  // toggle stuck header with cobrand
  const toggleStuckCobrand = (hasNavTop) => {
    setCurrentNav();
    if (!hasNav()) {
      return;
    }
    if ($currentNav.hasClass("nav-top") === hasNavTop) {
      return;
    }
    $currentNav.toggleClass("stuck-cobrand");
  };
  // end of cobrand

  // scrollbar measurement
  const scrollDiv = document.createElement("div");

  scrollDiv.className = "scrollbar-measure";
  document.body.appendChild(scrollDiv);

  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  document.body.removeChild(scrollDiv);
  // scrollbar measurement END

  const main = $main.waypoint({
    handler: () => {
      $header.toggleClass("header--stuck");
      $body.toggleClass("has-stuck-header");
      toggleStuckCobrand(false);
      $bookNowMobileBtn.toggleClass("hidden");
    },
    offset: 0,
  });

  $mainGroupsMenuTop.waypoint({
    handler: () => {
      $header.toggleClass("header--stuck");
      $body.toggleClass("has-stuck-header");
      toggleStuckCobrand(false);
    },
    offset: 54,
  });

  $currentNav.waypoint({
    handler: () => {
      toggleStuckCobrand(true);
    },
    offset: 38,
  });

  // main menu
  $menuBtn
    .on("click", function clickMenuBtn(e) {
      e.preventDefault();

      const $this = $(this);
      // const $images = $headerBottom.find('[data-src]');
      const $allLink = $mnNavbarList.find(".mn-navbar-link");
      const $allSmLink = $smNavbarList.find(".sm-navbar");
      const $allBlock = $(".js-mn-content-wrap");
      const isExpanded =
        e.currentTarget.getAttribute("aria-expanded") === "true";

      e.currentTarget.setAttribute("aria-expanded", `${!isExpanded}`);

      isMenuOpen = !isMenuOpen;

      // $images.Lazy();

      $allLink.removeClass("mn-navbar-link--active");
      $allBlock.removeClass("mn-content-wrap--open");
      $($($allLink)[0]).addClass("mn-navbar-link--active");
      $($($allSmLink)[0]).addClass("mn-navbar-link--active");
      $($($allBlock)[0]).addClass("mn-content-wrap--open");

      let ActualLocation = window.location.pathname;
      ActualLocation = ActualLocation.includes("rewards-program")
        ? "/about/rewards-program/"
        : ActualLocation;
      ActualLocation = ActualLocation.includes("all-inclusive")
        ? "/all-inclusive/"
        : ActualLocation;
      ActualLocation = ActualLocation.includes("activities")
        ? "/activities/"
        : ActualLocation;
      ActualLocation = ActualLocation.includes("vacations")
        ? "/vacations/"
        : ActualLocation;
      ActualLocation = ActualLocation.includes("weddings")
        ? "/weddings/"
        : ActualLocation;
      ActualLocation = ActualLocation.includes("weddingmoons")
        ? "/weddingmoons/"
        : ActualLocation;
      ActualLocation = ActualLocation.includes("deals")
        ? "/deals/"
        : ActualLocation;

      let AllRoutes = new Map([
        ["/resorts/", 0],
        ["/resorts/turks-caicos/", 0],
        ["/resorts/negril/", 0],
        ["/resorts/ocho-rios/", 0],
        ["/compare/", 0],
        ["/destinations/", 1],
        ["/turks-caicos/", 1],
        ["/jamaica/", 1],
        ["/all-inclusive/", 2],
        ["/activities/", 2],
        ["/scuba/", 2],
        ["/redlane-spa/", 2],
        ["/photo-video-services/", 2],
        ["/tours/", 2],
        ["/liv-plus/", 2],
        ["/vacations/", 3],
        ["/deals/bff/", 3],
        ["/groups/", 3],
        ["/accessibility-guide/", 3],
        ["/weddingmoons/", 4],
        ["/weddings/", 4],
        ["/engagements/", 4],
        ["/honeymoons/", 4],
        ["/anniversaries/", 4],
        ["/elopments/", 4],
        ["/vow-renewals/", 4],
        ["/deals/", 5],
        ["/groups/group-specials/", 5],
      ]);

      $allLink.removeClass("mn-navbar-link--active");
      $(
        $($allLink)[
          AllRoutes.get(ActualLocation) != null
            ? AllRoutes.get(ActualLocation)
            : 0
        ]
      ).addClass("mn-navbar-link--active");

      $allBlock.removeClass("mn-content-wrap--open");
      $(
        $($allBlock)[
          AllRoutes.get(ActualLocation) != null
            ? AllRoutes.get(ActualLocation)
            : 0
        ]
      ).addClass("mn-content-wrap--open");

      if ($(window).width() <= 767) {
        $(".js-mn-content-btn").parent().find(".mn-content").hide();
        // $('.js-mn-content-btn').parent('.mn-content-wrap--open-mb').find('.mn-content').hide();
      } else {
        $(".js-mn-content-btn").parent().find(".mn-content").fadeIn();
      }

      $allBlock.removeClass("mn-content-wrap--open-mb");

      $mobileResorts.removeClass("mobile-resorts--open");
      $body.removeClass("has-open-resorts");
      $html.removeClass("has-open-resorts");

      $this.toggleClass("hm-menu-btn--active");
      $headerBottom.toggleClass("header-bottom--open");

      if (isMenuOpen) {
        main[0].disable();

        $body.css({ "margin-right": scrollbarWidth });
        $header.css({
          left: "-" + scrollbarWidth + "px",
        });

        resortMenu && (resortMenu.style.left = `-${scrollbarWidth}px`);

        scrollTop = !isResortsOpen ? window.scrollY : 0;
        isResortsOpen = false;
        $body.toggleClass("has-open-menu");
        $html.toggleClass("has-open-menu");
      } else {
        $body.css({ "margin-right": 0 });
        $header.css({ left: 0 });
        resortMenu && (resortMenu.style.left = null);
        $body.toggleClass("has-open-menu");
        $html.toggleClass("has-open-menu");
        $window.scrollTop(scrollTop);

        main[0].enable();
      }
    })
    .on("keydown", (e) => {
      /**
       * KeyCodes
       * spacebar -> 32
       * enter -> 13
       * escape -> 27
       *
       * Handle user interactions with hamburger menu button
       */
      const { keyCode } = e.originalEvent;

      if (keyCode === 13 || keyCode === 32) {
        e.preventDefault();

        $menuBtn.toggleClass("hm-menu-btn--active");
        $headerBottom.toggleClass("header-bottom--open");
        isMenuOpen = !isMenuOpen;
      }

      if (keyCode === 27 && $menuBtn.hasClass("hm-menu-btn--active")) {
        $menuBtn.toggleClass("hm-menu-btn--active");
        $headerBottom.toggleClass("header-bottom--open");
        isMenuOpen = false;
      }
    });
  // main menu END
  $rewardsBtn
    .on("click", function clickMenuBtn(e) {

      
      //profileOptions.classList.remove('hide-options');
      const $allLink = $mnNavbarList.find(".mn-navbar-link");

      $allLink.removeClass("mn-navbar-link--active");

      if (!headerSignInBtn.classList.contains("js-rewards-btn")) {
    
        e.preventDefault();
        const $this = $(this);
        const $mainMenu = $(".hm-menu-btn");

        // const $images = $headerBottom.find('[data-src]');
        const $allSmLink = $smNavbarList.find(".sm-navbar");
        const $allBlock = $(".js-mn-content-wrap");
        const isExpanded =
          e.currentTarget.getAttribute("aria-expanded") === "true";

        e.currentTarget.setAttribute("aria-expanded", `${!isExpanded}`);

        isMenuOpen = !isMenuOpen;
        // $images.Lazy();

        $allSmLink.removeClass("sm-navbar-link--active");
        $allBlock.removeClass("mn-content-wrap--open");

        $($($allBlock)[6]).addClass("mn-content-wrap--open");

        if ($(window).width() <= 767) {
          $(".js-mn-content-btn").parent().find(".mn-content").hide();
          // $('.js-mn-content-btn').parent('.mn-content-wrap--open-mb').find('.mn-content').hide();
        } else {
          $(".js-mn-content-btn").parent().find(".mn-content").fadeIn();
        }

        $allBlock.removeClass("mn-content-wrap--open-mb");

        $mobileResorts.removeClass("mobile-resorts--open");
        $body.removeClass("has-open-resorts");
        $html.removeClass("has-open-resorts");


        $mainMenu.toggleClass("hm-menu-btn--active");
        $headerBottom.toggleClass("header-bottom--open");

        if (isMenuOpen) {
          main[0].disable();

          $body.css({ "margin-right": scrollbarWidth });
          $header.css({
            left: "-" + scrollbarWidth + "px",
          });

          rewardsMenu && (rewardsMenu.style.left = `-${scrollbarWidth}px`);

          scrollTop = !isResortsOpen ? window.scrollY : 0;
          isResortsOpen = false;
          $body.toggleClass("has-open-menu");
          $html.toggleClass("has-open-menu");
        } else {
          $body.css({ "margin-right": 0 });
          $header.css({ left: 0 });
          rewardsMenu && (rewardsMenu.style.left = null);
          $body.toggleClass("has-open-menu");
          $html.toggleClass("has-open-menu");
          $window.scrollTop(scrollTop);

          main[0].enable();
        }
      }
    })
    .on("keydown", (e) => {
      /**
       * KeyCodes
       * spacebar -> 32
       * enter -> 13
       * escape -> 27
       *
       * Handle user interactions with hamburger menu button
       */

      const { keyCode } = e.originalEvent;

      if (keyCode === 13 || keyCode === 32) {
        e.preventDefault();

        $mainMenu.toggleClass("hm-menu-btn--active");
        $headerBottom.toggleClass("header-bottom--open");
        isMenuOpen = !isMenuOpen;
      }

      if (keyCode === 27 && $menuBtn.hasClass("hm-menu-btn--active")) {
        $mainMenu.toggleClass("hm-menu-btn--active");
        $headerBottom.toggleClass("header-bottom--open");
        isMenuOpen = false;
      }
    });
  // sign in button END

  //second sign in button 
  $rewardsBtn2
  .on("click", function clickMenuBtn(e) {

    const $allLink = $mnNavbarList.find(".mn-navbar-link");

    $allLink.removeClass("mn-navbar-link--active");

    if (!headerSignInBtn.classList.contains("js-rewards-btn")) {
  
      e.preventDefault();
      const $this = $(this);
      const $mainMenu = $(".hm-menu-btn");

      // const $images = $headerBottom.find('[data-src]');
      const $allSmLink = $smNavbarList.find(".sm-navbar");
      const $allBlock = $(".js-mn-content-wrap");
      const isExpanded =
        e.currentTarget.getAttribute("aria-expanded") === "true";

      e.currentTarget.setAttribute("aria-expanded", `${!isExpanded}`);

      isMenuOpen = !isMenuOpen;
      // $images.Lazy();

      $allSmLink.removeClass("sm-navbar-link--active");
      $allBlock.removeClass("mn-content-wrap--open");

      $($($allBlock)[6]).addClass("mn-content-wrap--open");

      if ($(window).width() <= 767) {
        $(".js-mn-content-btn").parent().find(".mn-content").hide();
        // $('.js-mn-content-btn').parent('.mn-content-wrap--open-mb').find('.mn-content').hide();
      } else {
        $(".js-mn-content-btn").parent().find(".mn-content").fadeIn();
      }

      $allBlock.removeClass("mn-content-wrap--open-mb");

      $mobileResorts.removeClass("mobile-resorts--open");
      $body.removeClass("has-open-resorts");
      $html.removeClass("has-open-resorts");


      $mainMenu.toggleClass("hm-menu-btn--active");
      $headerBottom.toggleClass("header-bottom--open");

      if (isMenuOpen) {
        main[0].disable();

        $body.css({ "margin-right": scrollbarWidth });
        $header.css({
          left: "-" + scrollbarWidth + "px",
        });

        rewardsMenu && (rewardsMenu.style.left = `-${scrollbarWidth}px`);

        scrollTop = !isResortsOpen ? window.scrollY : 0;
        isResortsOpen = false;
        $body.toggleClass("has-open-menu");
        $html.toggleClass("has-open-menu");
      } else {
        $body.css({ "margin-right": 0 });
        $header.css({ left: 0 });
        rewardsMenu && (rewardsMenu.style.left = null);
        $body.toggleClass("has-open-menu");
        $html.toggleClass("has-open-menu");
        $window.scrollTop(scrollTop);

        main[0].enable();
      }
    }
  })
  .on("keydown", (e) => {
    /**
     * KeyCodes
     * spacebar -> 32
     * enter -> 13
     * escape -> 27
     *
     * Handle user interactions with hamburger menu button
     */

    const { keyCode } = e.originalEvent;

    if (keyCode === 13 || keyCode === 32) {
      e.preventDefault();

      $mainMenu.toggleClass("hm-menu-btn--active");
      $headerBottom.toggleClass("header-bottom--open");
      isMenuOpen = !isMenuOpen;
    }

    if (keyCode === 27 && $menuBtn.hasClass("hm-menu-btn--active")) {
      $mainMenu.toggleClass("hm-menu-btn--active");
      $headerBottom.toggleClass("header-bottom--open");
      isMenuOpen = false;
    }
  });
// sign in button END

  /**
   * Keyboard accessibility functionality
   * for Hamburger Menu Content
   *
   * KeyCodes
   * spacebar -> 32
   * enter -> 13
   * escape -> 27
   *
   */
  $headerBottom.on("keyup", (e) => {
    const { keyCode, shiftKey } = e.originalEvent;
    const { activeElement } = document;
    const mainMenuWrapper = document.querySelector(".mn-navbar-col");
    const mainContentWrapper = document.querySelector(".mn-content-col");
    const isMainMenuElement = mainMenuWrapper.contains(activeElement);
    const isContentElement = mainContentWrapper.contains(activeElement);
    const activeContentId = mainContentWrapper.querySelector(
      ".js-mn-content-wrap.mn-content-wrap--open"
    ).id;

    /**
     * if the user tries to go back
     * using SHIFT+TAB evaluate
     * the current target and
     * change focus accordingly
     */
    if (
      keyCode === 9 &&
      shiftKey &&
      e.target.classList.contains("js-mn-content-wrap")
    ) {
      if (isContentElement) {
        const mainMenuItem = mainMenuWrapper.querySelector(
          `a[data-link="#${activeContentId}"]`
        ).parentElement;

        if (mainMenuItem) {
          mainMenuItem.children[0].focus();
        }
      }
    }

    /**
     * if the user presses the ESCAPE KEY inside the main menu
     * we need to evaluate which element he is focused on
     */
    if (keyCode === 27) {
      /**
       * if the focus is on a main menu item
       * the main menu should be closed
       */
      if (isMainMenuElement) {
        $menuBtn.toggleClass("hm-menu-btn--active");
        $headerBottom.toggleClass("header-bottom--open");
        isMenuOpen = false;
      }
      /**
       * if the focus is on a content item
       * the focus needs to go back to the related main menu item
       */
      if (isContentElement) {
        const nextMainMenuItem = mainMenuWrapper.querySelector(
          `a[data-link="#${activeContentId}"]`
        ).parentElement.nextElementSibling;

        if (nextMainMenuItem) {
          nextMainMenuItem.children[0].focus();
        } else {
          document
            .querySelector(".mn-navbar-sm-list .mn-navbar-sm-item")
            .children[0].focus();
        }
      }
    }
  });

  /**
   * Blur handler for all links in each submenu
   * if the user gets to the last link inside a submenu
   * we need to programmatically set the focus to the next
   * main menu item.
   */
  $(".mn-content-col").on("blur", "a", (e) => {
    setTimeout(() => {
      const { activeElement } = document;
      const mainMenuWrapper = document.querySelector(".mn-navbar-col");
      const mainContentWrapper = document.querySelector(".mn-content-col");
      const isContentElement = mainContentWrapper.contains(activeElement);

      if (!isContentElement) {
        const $focusableElements = [
          ...document.querySelectorAll(
            ".mn-content-wrap--open .mn-content a[href]"
          ),
        ];
        const previousElementIndex = $focusableElements.findIndex(
          (el) => el === e.target
        );

        if (previousElementIndex === $focusableElements.length - 1) {
          const mainMenuParentItemId = mainContentWrapper.querySelector(
            ".js-mn-content-wrap.mn-content-wrap--open"
          ).id;
          const nextMainMenuItem = mainMenuWrapper.querySelector(
            `a[data-link="#${mainMenuParentItemId}"]`
          ).parentElement.nextElementSibling;

          if (nextMainMenuItem) {
            nextMainMenuItem.children[0].focus();
          } else {
            document
              .querySelector(".mn-navbar-sm-list .mn-navbar-sm-item")
              .children[0].focus();
          }
        }
      }
    }, 0);
  });

  /**
   * Event Listener to handle when the main menu
   * should be closed while the user uses the tab key
   */
  $(".mn-navbar-sm-list").on("blur", "a", () => {
    setTimeout(() => {
      const $menuWrapper = document.querySelector(".mn-navbar-sm-list");
      const { activeElement } = document;
      const isMenuItem = $menuWrapper.contains(activeElement);

      if (!isMenuItem) {
        $menuBtn.trigger("click");
      }
    }, 0);
  });

  // hide a main menu when the user clicks outside of it
  if (window.innerWidth > 1200) {
    $document.on("click touchstart", (e) => {
      if (
        !$header.is(e.target) &&
        $header.has(e.target).length === 0 &&
        isMenuOpen
      ) {
        $menuBtn.trigger("click");
      }
    });
  }
  // hide a main menu when the user clicks outside of it END

  // mobile accordion
  $mnContentBtn.on("click", function clickContentBtn(e) {
    e.preventDefault();

    const $this = $(this);
    const $parent = $this.parent();

    $parent.toggleClass("mn-content-wrap--open-mb");
    $parent.find(".mn-content").slideToggle(400);
  });
  // mobile accordion END

  // desktop accordion
  let clickMouseEnter = "mouseenter click focus";
  let isDesktop = true;

  if (window.innerWidth < 992) {
    clickMouseEnter = "click";
    isDesktop = false;
  }

  $mnNavbarList
    .on(clickMouseEnter, ".mn-navbar-link", function clickNavbarList(e) {
      if (isDesktop && e.type === "click") {
        // const link = e.currentTarget.dataset.link;
        // window.location = link;
      } else {
        e.preventDefault();

        const $this = $(this);
        const $allBlock = $(".js-mn-content-wrap");
        const $allLink = $mnNavbarList.find(".mn-navbar-link");
        let $block;

        if ($(e.target).is("a")) {
          $block = $($(e.target).attr("data-link"));
        } else {
          $block = $($(e.target).parents("a").attr("data-link"));
        }

        $allLink.removeClass("mn-navbar-link--active");
        $this.addClass("mn-navbar-link--active");
        $allBlock.removeClass("mn-content-wrap--open");
        $block.addClass("mn-content-wrap--open");
      }
    })
    .on("keydown", ".mn-navbar-link", (e) => {
      /**
       * If tab key is pressed while in a main menu item
       * the focus should change to that item's submenu
       *
       * KeyCodes
       * spacebar -> 32
       * enter -> 13
       * escape -> 27
       * tab -> 9
       */
      const { keyCode, shiftKey } = e.originalEvent;

      if (keyCode === 9 && !shiftKey) {
        const { target } = e;
        const { link } = target.dataset;

        // link represents the item's submenu wrapper
        $(link).focus();
      }
    });
  // desktop accordion END

  // sublist accordion
  $smNavbarList
    .on(clickMouseEnter, ".sm-navbar", function clickNavbarList(e) {
      if (isDesktop && e.type === "click") {
        // const link = e.currentTarget.dataset.link;
        // window.location = link;
      } else {
        e.preventDefault();

        const $this = $(this);
        const $allBlock = $(".js-mn-content-wrap");
        const $allLink = $mnNavbarList.find(".sm-navbar");
        let $block;

        if ($(e.target).is("a")) {
          $block = $($(e.target).attr("data-link"));
        } else {
          $block = $($(e.target).parents("a").attr("data-link"));
        }

        $allLink.removeClass("sm-navbar--active");
        $this.addClass("sm-navbar--active");
        $allBlock.removeClass("mn-content-wrap--open");
        $block.addClass("mn-content-wrap--open");
      }
    })
    .on("keydown", ".sm-navbar", (e) => {
      /**
       * If tab key is pressed while in a main menu item
       * the focus should change to that item's submenu
       *
       * KeyCodes
       * spacebar -> 32
       * enter -> 13
       * escape -> 27
       * tab -> 9
       */
      const { keyCode, shiftKey } = e.originalEvent;

      if (keyCode === 9 && !shiftKey) {
        const { target } = e;
        const { link } = target.dataset;

        // link represents the item's submenu wrapper
        $(link).focus();
      }
    });
  // sublist accordion END

  // custom select
  $customSelects.each(function eachCustomSelects(key, item) {
    $(item).selectmenu({ appendTo: $(this).parents(".check-rates") });
  });

  $bookNowButton.on("mouseover", () => {
    $bookNowButton.addClass("hovered");
  });
  $bookNowButton.on("mouseleave", () => {
    $bookNowButton.removeClass("hovered");
  });

  $bookNowOverlay.on("click", () => {
    $bookNowButton.removeClass("active");
  });

  $bookNowCloseBtn.on("click", (e) => {
    e.stopImmediatePropagation();
    $bookNowButton.removeClass("active");
    $bookNowButton.removeClass("hovered");
  });

  for (let index = 0; index < quickQuoteElms.length; index++) {
    ReactDOM.render(
      <QuickQuote
        className="qq-rst-menu"
        quoteButtonText="Get Quote"
        controlThemeClassName="control-small dark-side"
        brand="beaches"
      />,
      quickQuoteElms[index]
    );
  }

  window.addEventListener(
    "resize",
    _globalUtils.debounce(() => {
      if (window.innerWidth > 767) {
        $headerBottom.scrollTop(0);
        $header.css("left", "0px");
        // $toggleBtnOpenResorts.trigger('click');
      }
      if (window.innerWidth > 320) {
        $mobileResorts.removeClass("mobile-resorts--open");
      }
    }, 200)
  );
};

export default header;
